import { ChangeEvent, useCallback } from 'react';
import { useFormContext } from 'react-hook-form';

type Formatter = (input: string) => string;

export function useFormatOnChange(fieldName: string, format: Formatter) {
	const { setValue } = useFormContext();

	return useCallback(
		(e: ChangeEvent<HTMLInputElement>) => {
			const formattedValue = format(e.target.value);

			if (formattedValue !== e.target.value) {
				setValue(fieldName, formattedValue);
			}
		},
		[format, setValue, fieldName],
	);
}
